import React, { useEffect, useRef, useState } from "react";
import Search from "../../../../../../components/Search";
import { useDispatch, useSelector } from "react-redux";
import { Divider, Dropdown, Form, Select, Table } from "antd";
import svg27 from "../../../../../../assets/svg/svg27.svg";
import svg12 from "../../../../../../assets/svg/svg12.svg";
import svg13 from "../../../../../../assets/svg/svg13.svg";
import svg29 from "../../../../../../assets/svg/svg29.svg";
import CardLoading from "../../../../../../components/CardLoading";
import { Link, useNavigate } from "react-router-dom";
import { fetchData } from "../../../../../../features/fetch/fetchSlice";
import { formatText } from "../../../../../../utils";
import moment from "moment";
import useModalToggle from "../../../../../../custom_hooks/useModalToggle";
import ConfirmModal from "../../../../../../components/ConfirmModal";
import toast from "react-hot-toast";
import { save } from "../../../../../../features/save/saveSlice";
import ComponentAdd from "./modal/ComponentAdd";

function ComponentsTable() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const url = "api/v2/mainProject/components/get";
  const { loading, data, count, activeObjOngoingProject } = useSelector(
    (state) => ({
      loading: state.fetch.loading,
      data: state.fetch.data[url] || [],
      count: state.fetch.count[url] || 0,
      activeObjOngoingProject: state.obj.activeObj["ongoingProject"],
    })
  );
  const { refetchKey } = useSelector((state) => state.global);

  const { open, handleCancel, handleOpen } = useModalToggle();

  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        compProjectId: activeObjOngoingProject?.projectId,
        compName: e.target.value == "" ? null : e.target.value,
      })
    );
  };
  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleDelete = async () => {
    const res = await dispatch(
      save({
        url: "api/v2/mainProject/components/delete",
        componentId: prodd?.componentId,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await setOpenDelete(false);
      await fetchTableData();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const handleEdit = async () => {
    await handleOpen();
  };
  const handleAdd = async () => {
    await setProdd();
    await handleOpen();
  };

  const settingItems = [
    {
      key: "1",
      label: (
        <div onClick={handleEdit}>
          <Link className="flex actions-text gap-x-[.75rem] my-2 w-4 h-4 ">
            <img src={svg12} alt="svg12" /> Edit
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div onClick={handleOpenDelete}>
          <Link className="flex items-center gap-x-2 actions-text my-2">
            <img src={svg13} alt="svg13" className="w-4 h-4" />
            <span className="whitespace-nowrap">Delete</span>
          </Link>
        </div>
      ),
    },
  ];

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Component",
      dataIndex: "compName",
      sorter: (a, b) => a.compName.localeCompare(b.compName),
    },

    {
      title: "Weight",
      dataIndex: "compWeight",
      sorter: (a, b) => a.compWeight.localeCompare(b.compWeight),
    },
    {
      title: "% Completed",
      dataIndex: "compPercentageCompleted",
      sorter: (a, b) =>
        a.compPercentageCompleted.localeCompare(b.compPercentageCompleted),
    },

    {
      title: "Last Updated By",
      dataIndex: "lastModifiedBy",
      sorter: (a, b) => a.lastModifiedBy.localeCompare(b.lastModifiedBy),
    },
    {
      title: "Status",
      dataIndex: "compStatus",
      render: (item) => {
        const colors = {
          ACTIVE: "#28A745",
          COMPLETED: "#3250FF",
          STALLED: "#F44336",
        };

        return (
          <div
            className="text-[#FFF] inline-block rounded-[8px] px-[8px] py-[4px] w-auto !text-[12px]"
            style={{
              backgroundColor: colors[item] || "darkGreen",
            }}
          >
            {formatText(item)}
          </div>
        );
      },
    },
    ...(!["COMPLETED", "STALLED"]?.includes(activeObjOngoingProject?.projectStatus)
      ? [
          {
            title: "Actions",
            render: (item) => (
              <>
                <Dropdown
                  overlayStyle={{
                    width: "250px",
                  }}
                  trigger={"click"}
                  menu={{ items: settingItems }}
                  placement="bottom"
                >
                  <button onClick={() => setProdd(item)}>
                    <img src={svg27} alt="svg27" />
                  </button>
                </Dropdown>
              </>
            ),
          },
        ]
      : []),
  ];

  const onFinish = () => {};

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        compProjectId: activeObjOngoingProject?.projectId,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  useEffect(() => {
    if (refetchKey == 3) {
      fetchTableData();
    }
  }, [refetchKey]);

  if (loading && !searchInput) return <CardLoading />;
  return (
    <div className="flex flex-col w-full  flex-1">
      <div className="flex lg:flex-row flex-col lg:items-center justify-between  gap-y-4">
        <div className="form-add-h">Project Components</div>
        <div className="flex flex-wrap items-center lg:justify-end justify-start gap-[.62rem]">
          <div className="lg:w-[16.125rem] w-full  ">
            <Search
              searchInput={searchInput}
              handleSearch={handleSearch}
              text={"Search"}
            />
          </div>
          {activeObjOngoingProject?.projectStatus === "COMPLETED" || activeObjOngoingProject?.projectStatus === "STALLED" ? null : (
            <div className="w-[200px]">
              <button onClick={() => handleAdd()} className="cstm-btn-2">
                <img src={svg29} alt="svg29" />{" "}
                <span className="ml-1">Add Component</span>
              </button>
            </div>
          )}
        </div>
      </div>

      <div className="max-w-full w-full overflow-x-auto">
        <Table
          rowSelection={false}
          className="mt-[1.75rem] w-full"
          scroll={{
            x: 1200,
          }}
          rowKey={(record) => record?.componentId}
          columns={columns}
          dataSource={data}
          loading={loading}
          summary={() => {
            const total = data.reduce(
              (sum, item) => sum + (parseFloat(item.compWeight) || 0),
              0
            );
            const capped = Math.min(total, 100);
            return (
              <Table.Summary.Row>
                <Table.Summary.Cell colSpan={2}>
                  <span className="font-bold">Total</span>
                </Table.Summary.Cell>
                <Table.Summary.Cell />
                <Table.Summary.Cell>
                  <span
                    className="font-bold"
                    style={{ color: total > 100 ? "#F44336" : "#28A745" }}
                  >
                    {capped}%{total > 100 && ` (sum: ${total.toFixed(1)}%)`}
                  </span>
                </Table.Summary.Cell>
                <Table.Summary.Cell colSpan={3} />
              </Table.Summary.Row>
            );
          }}
          pagination={{
            position: ["bottomRight"],
            current: pageIndex + 1,
            total: count,
            pageSize: pageSize,
            onChange: (page, size) => {
              setPageIndex(page - 1);
              setPageSize(size);
              fetchTableData(page - 1, size);
            },
            showSizeChanger: false,
            hideOnSinglePage: true,
          }}
        />
      </div>

      <ComponentAdd
        isModalOpen={open}
        handleCancel={handleCancel}
        handleFetch={fetchTableData}
        prodd={prodd}
      />

      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={loading}
        content="Are you sure you want perfom this action?"
        type="alert"
        btnTitle="Delete"
      />
    </div>
  );
}

export default ComponentsTable;
